<template>
  <v-container fluid class="summary">
    <!--BEGIN --profile details-->
    <v-alert type="info" text shaped v-if="!profileCompleted">
      <v-row align="center">
        <v-col class="grow">
          <p justify>
            Hi {{ user.name }}! Your profile is 90% complete
            <small>
              &nbsp;&nbsp; - Fill 100% of your profile to help us find the best
              services for you.
            </small>
          </p>
        </v-col>
        <v-col class="shrink">
          <v-btn color="warning" elevation="0" @click="redirectToPending">
            Complete Profile
            <!-- <v-icon class="ml-1">mdi-arrow-right</v-icon> -->
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
    <!--END Profile Incomplete Alert-->
    <v-card flat class="mb-5">
      <v-card-text>
        <!--BEGIN confirmation alert-->
        <v-dialog v-model="dialog" width="500">
          <v-card>
            <v-card-title>
              <v-spacer />
              <v-btn text @click="dialog = false">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="summary">
              <v-row class="image">
                <v-col cols="12" md="4">
                  <v-img
                    width="150"
                    height="150"
                    class="text-center"
                    src="../../../assets/mini-intake-intro.png"
                  />
                </v-col>
                <v-col cols="12" md="8">
                  <div class="ma-4">
                    <h3>Update your profile!</h3>
                    <v-divider class="my-2" />
                    <p class="">
                      Hey there, looks like you haven’t updated your information
                      in a long time. Please update information to access our
                      services.
                    </p>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="redirectToPending">
                Continue
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!--END confirmation alert-->
        <v-row>
          <v-col cols="12" md="6" sm="12">
            <v-card flat class="courses-container">
              <div class="ma-auto pa-md-4">
                <v-avatar size="85">
                  <v-img
                    :src="
                      bioData.base64Image
                        ? `data:${getImage(bioData.base64Image)};base64, ${
                            bioData.base64Image
                          }`
                        : imageUrl
                    "
                  ></v-img>
                </v-avatar>
              </div>
              <div class="course-info mx-auto">
                <v-list class="align-center mx-auto" dense>
                  <v-list-item>
                    <h4>
                      Name:
                      <span class="font-weight-light"
                        >{{ bioData !== null ? bioData.lastName : "" }}
                        {{ bioData !== null ? bioData.firstName : "" }}
                        {{
                          bioData !== null ? bioData["secondName"] : ""
                        }}</span
                      >
                    </h4>
                  </v-list-item>
                  <v-list-item>
                    <h4>
                      Email:
                      <span class="font-weight-light">{{
                        bioData !== null ? bioData.email : ""
                      }}</span>
                    </h4>
                  </v-list-item>
                  <v-list-item>
                    <h4>
                      National ID:
                      <span class="font-weight-light">{{
                        bioData !== null ? bioData.identificationDocumentNo : ""
                      }}</span>
                    </h4>
                  </v-list-item>
                  <v-list-item>
                    <h4>
                      Student ID:
                      <span class="font-weight-light">{{
                        bioData !== null ? bioData.studentID : "Null"
                      }}</span>
                    </h4>
                  </v-list-item>
                </v-list>
                <v-card-actions class="d-flex flex-column">
                  <v-btn
                    block
                    class="btn text-capitalize mb-3"
                    color="primary"
                    :to="{ name: 'AccountSettings' }"
                  >
                    My Account
                  </v-btn>
                  <BankingInformation />
                </v-card-actions>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" v-if="$vuetify.breakpoint.smAndDown">
            <v-divider />
          </v-col>
          <v-divider v-else vertical />
          <!--END the profile details-->
          <!--BEGIN the programme details-->
          <v-col cols="12" md="6">
            <v-row>
              <v-card-text class="text-center">
                <h1 class="text-h3 font-weight-light primary--text">
                  {{
                    currentRegistration !== null
                      ? currentRegistration && currentRegistration.programme
                        ? currentRegistration.programme
                        : ""
                      : ""
                  }}
                </h1>
                <v-card-subtitle> Current Programme </v-card-subtitle>
              </v-card-text>
            </v-row>
            <v-divider />
            <v-row>
              <v-col cols="12" md="8">
                <v-list dense class="course-info pl-md-4 px-sm-16">
                  <v-list-item>
                    <v-list-item-title><h4>Intake:</h4></v-list-item-title>
                    <v-list-item-subtitle>
                      <span class="font-weight-regular">
                        {{
                          currentRegistration
                            ? currentRegistration.intakeYear
                            : ""
                        }},
                        {{
                          currentRegistration
                            ? currentRegistration.intakeSemester
                            : ""
                        }}
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title><h4>Stage:</h4></v-list-item-title>
                    <v-list-item-subtitle>
                      <span class="font-weight-regular">
                        {{
                          currentRegistration
                            ? currentRegistration.intakeStage
                            : ""
                        }}
                      </span>
                    </v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-col>
              <v-col cols="12" md="2" class="my-auto">
                <v-card-actions>
                  <v-btn
                    class="btn text-capitalize"
                    color="primary"
                    @click="$router.push({ name: 'RegistrationList' })"
                  >
                    Renew
                  </v-btn>
                </v-card-actions>
              </v-col>
              <v-col cols="12" md="12" sm="12">
                <PastPapers />
              </v-col>
            </v-row>
          </v-col>
          <!--END the programme details-->
        </v-row>
      </v-card-text>
    </v-card>
    <!--END profile details-->
    <!--BEGIN statistics-->
    <DashboardStats
      :currentRegistration="currentRegistration"
      :currentProgramme="currentProgramme"
      :minorSettings="minorSettings"
    />
    <!--END statistics-->
  </v-container>
</template>

<script>
import helpers from "../../../utils/helpers/helper.js";
import { AuthService } from "../../auth";
import DashboardStats from "./DashboardStats";
import PastPapers from "./PastPapers.vue";
import BankingInformation from "./BankingInformation.vue";
export default {
  name: "SummariesComponent",
  components: { DashboardStats, PastPapers, BankingInformation },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Profile/getProfile");
      v.$store.dispatch(
        "Application/getAllApplications",
        v.user.profile.profileID,
      );
      v.$store.dispatch("Exam/studentExamResults");
      window.document.title = "KISEB::Dashboard Stats";
    });
  },
  data: () => ({
    value: 0,
    dialog: false,
    listItem: {
      student: "",
    },
    imageUrl:
      "https://www.icmetl.org/wp-content/uploads/2020/11/user-icon-human-person-sign-vector-10206693.png",
  }),
  mounted() {
    window.localStorage.setItem(
      "programmeCode",
      this.currentRegistration?.programme,
    );
  },
  computed: {
    user() {
      return AuthService.user;
    },
    bioData() {
      return this.$store.getters["Profile/bioData"];
    },
    currentProgramme() {
      return this.$store.getters["Dashboard/currentProgramme"][0];
    },
    currentRegistration() {
      const prog = this.currentProgramme;
      return prog
        ? {
            ...prog,
            programmeAPI: prog.programmeAPI,
          }
        : null;
    },
    totalExemptedUnits() {
      return this.currentRegistration
        ? this.currentRegistration.totalExemptedUnits
        : null;
    },
    unitsTaken() {
      return this.currentRegistration
        ? this.currentRegistration.unitsTaken
        : null;
    },
    profileCompleted() {
      let complete = true;
      this.$store.getters["Checklist/checklist"].filter((item) => {
        if (!item.pass) {
          complete = false;
          this.dialog = true;
        }
      });
      return complete;
    },
    settings() {
      return this.$store.getters["Dashboard/settings"];
    },
    minorSettings() {
      return JSON.parse(this.settings?.minor_settings || "{}");
    },
  },
  methods: {
    getImage(base64) {
      return helpers.detectMimeType(base64);
    },
    redirectToPending() {
      this.$router.push({ name: "PendingList", params: { type: "Profile" } });
    },
  },
  watch: {
    totalExemptedUnits: {
      handler: function () {
        this.value = this.totalExemptedUnits;
      },
    },
  },
};
</script>

<style scoped>
@import url("../styles/dashboard.css");
@import url("https://fonts.googleapis.com/css2?family=PT+Sans+Caption&display=swap");
* {
  box-sizing: border-box;
}
.summary {
  font-family: "PT Sans Caption", sans-serif;
}
.courses-container {
  display: flex;
  height: 100%;
}
.course-info h4 {
  word-break: break-word;
}

.btn {
  border: 0;
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.2);
  color: #fff;
  font-size: 16px;
  letter-spacing: 1px;
}
</style>
